"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionSteps = void 0;
const value_wrappers_1 = require("../value-wrappers");
const text_with_placeholders_1 = require("./text-with-placeholders");
function questionSteps(stepsToParse, state) {
    const steps = stepsToParse.map((step) => {
        var _a;
        if (step.type === 'string') {
            step = Object.assign(Object.assign({}, step), { value: (0, text_with_placeholders_1.tokeniseString)(step.value, state).value });
        }
        else if (step.type === 'input-view' || step.type === 'output-view') {
            step = Object.assign(Object.assign({}, step), { text: (0, text_with_placeholders_1.tokeniseString)(step.text, state).value });
        }
        else if (step.type === 'equation') {
            step = Object.assign(Object.assign({}, step), { value: ((_a = step.value) !== null && _a !== void 0 ? _a : '').split('=').map((v) => (0, text_with_placeholders_1.tokeniseString)(v, state).value) });
        }
        else if (step.items) {
            const items = step.items.map((item) => {
                const tokens = (0, text_with_placeholders_1.tokeniseString)(item.text, state);
                return item.type === 'text' ? Object.assign(Object.assign({}, item), { value: tokens.value, variables: tokens.variables }) : item;
            });
            step = Object.assign(Object.assign({}, step), { items, variables: [...items.reduce((soFar, item) => {
                        var _a;
                        for (const v of ((_a = item.variables) !== null && _a !== void 0 ? _a : []))
                            soFar.add(v);
                        return soFar;
                    }, new Set())] });
        }
        return step;
    });
    const stepVariables = [...steps.reduce((soFar, step) => {
            var _a;
            for (const v of ((_a = step.variables) !== null && _a !== void 0 ? _a : []))
                soFar.add(v);
            return soFar;
        }, new Set())];
    return (0, value_wrappers_1.makeValue)(steps, stepVariables);
}
exports.questionSteps = questionSteps;
